"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getEmailVerificationEndpoint = void 0;

var getEmailVerificationEndpoint = function getEmailVerificationEndpoint(userId) {
  return "users/v1/users/" + userId + "/verifications/sales";
};

exports.getEmailVerificationEndpoint = getEmailVerificationEndpoint;